import { render, staticRenderFns } from "./SIRapor.vue?vue&type=template&id=268f1b89&"
import script from "./SIRapor.vue?vue&type=script&lang=js&"
export * from "./SIRapor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports